import { render, staticRenderFns } from "./ManuallyCreateLabAutomateV2.vue?vue&type=template&id=fb5dc4dc&scoped=true"
import script from "./ManuallyCreateLabAutomateV2.vue?vue&type=script&lang=js"
export * from "./ManuallyCreateLabAutomateV2.vue?vue&type=script&lang=js"
import style0 from "./ManuallyCreateLabAutomateV2.vue?vue&type=style&index=0&id=fb5dc4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5dc4dc",
  null
  
)

export default component.exports